export const formatNumber = (num: number): string => {
  if (num === 0) return '0'; // Handle zero case

  const isNegative = num < 0;
  num = Math.abs(num); // Work with positive numbers

  const units = ['', 'K', 'M', 'B', 'T'];
  let unitIndex = 0;

  while (num >= 1000 && unitIndex < units.length - 1) {
    num /= 1000;
    unitIndex++;
  }

  // Only use toFixed(2) if the number is not an integer or if it's a large number
  const formattedNum = num % 1 !== 0 || unitIndex > 0 ? num.toFixed(2) : num.toString();

  return (isNegative ? '-' : '') + formattedNum + units[unitIndex];
};

export const formatPercentage = (num: number) => `${num.toFixed(2)}%`;
